import React from 'react';
import {Route, Routes} from "react-router-dom";
import Table from "./Table";
import Add from "./Add";

function Index(props) {
    return (
        <Routes>
            <Route path="/" element={<Table/>}/>
            <Route path="/add" element={
                <Add />
            }/>

        </Routes>
    );
}

export default Index;